export const siteData = {
  phone: "03-9782288",
  mobile1: "0910-071850",
  mobile2: "0912-588105",
  lineId: "0910071850",
  wechatId: "ab0912588105",
  email: "ab0912588105@gmail.com",
  bank: {
    name: "瑞晟科技企業社",
    code: "822中國信託宜蘭分行",
    account: "727-540-106682"
  }
};

export const packagesData = [
  {
    id: 1,
    title: "賞鯨 + 龜山八景(牛奶海)",
    subtitle: "二合一行程",
    duration: "2.5 小時",
    time: "非假日 09:00 / 假日 10:30, 13:00",
    desc: "乘風破浪尋找海豚蹤跡，近距離觀賞龜山島獨特的地質景觀與夢幻牛奶海。",
    image: "https://images.unsplash.com/photo-1568430462989-44163eb17ab2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 2,
    title: "登島 + 龜山八景(牛奶海)",
    subtitle: "二合一行程",
    duration: "3 小時",
    time: "09:00, 13:00 (週三不開放)",
    desc: "踏上神秘的龜山島，一窺豐富的生態與歷史遺跡，並環繞島嶼欣賞美麗海景。",
    image: "https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 3,
    title: "賞鯨 + 登島 + 龜山八景(牛奶海)",
    subtitle: "三合一行程",
    duration: "4 小時",
    time: "09:00, 13:00 (週三不開放)",
    desc: "最受歡迎的完整體驗！結合海上賞鯨、島上探險與環島美景，一次滿足。",
    image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 4,
    title: "401高地 + 登島 + 龜山八景",
    subtitle: "深度三合一行程",
    duration: "7 小時",
    time: "08:00 - 09:00 (週三不開放)",
    desc: "挑戰龜山島至高點 401 高地，俯瞰太平洋壯麗全景，深入體驗生態之美。",
    image: "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
  }
];

export const newsData = [
  {
    id: 1,
    date: "2022-07-08",
    title: "LINE-ID 聯絡資訊更新",
    content: "如果這個LINE-ID:0912588105出現無法增加人數時，請加主要LINE-ID:0910071850，二個均可使用，請各位旅客放心使用，謝謝您。"
  },
  {
    id: 2,
    date: "2022-02-05",
    title: "宜蘭 – 知性之旅 – 龜山島",
    content: "位於宜蘭東面海域，龜山島靜靜的坐落於太平洋上。每年開放登島的時間只有三月到十一月！讓最專業的團隊帶您走過島上的戰地遺跡、環繞島上的龜尾湖。暑假期間參加人數眾多，提早 30 天報名才可以確保登島證之申請。"
  },
  {
    id: 3,
    date: "2022-02-05",
    title: "海豚雙魚照＆20週年【鯨夏一跳】",
    content: "本公司 20 週年慶祝活動，舉辦【鯨夏一跳】，賞鯨、登龜山島、登 401 高地、牛奶海全面優惠價中！包含二合一、三合一及 401 高地等多種行程選擇，請來電報名詢問優惠活動。"
  },
  {
    id: 4,
    date: "2022-02-05",
    title: "與海洋共舞 – 賞鯨豚",
    content: "每年七月到十月，黑潮洋流流經台灣東部海域，隨之而來覓食的海豚，穿梭在清澈海水中曼妙的舞姿。讓我們最專業的團隊帶您在海上尋找海豚、鯨魚的蹤跡，暑假請提早 21 日報名。"
  },
  {
    id: 5,
    date: "2020-11-15",
    title: "全新網站上線！歡迎光臨",
    content: "歡迎光臨宜蘭賞鯨龜山島快樂遊！新網站結合ＲＷＤ響應式網頁設計，以更專業的形象，更棒的瀏覽品質，呈現給您，請舊雨新知不吝指教！"
  }
];